export enum Navigations {
    DASHBOARD = "/main/dashboard",
    ADMIN_PERMISSIONS = "/main/admin-permission",
    PERMISSION_DETAILS = "/main/user-details",
    EXAMINATION = "/examination/test",
    INSTALL_PLUGIN_PAGE = "/examination",
    BASIC_DETAILS = "/basic-details",
    PROFILE_DETAILS = "/profile-details",
    NEW_PROFILE_DETAILS='/new-profile-details',
    VERIFY_EMAIL='/verify-email',
    AUDIO_VIDEO_SETUP = "/main/examination/audio-video-setup",
    GROUND_RULES = "/main/examination/ground-rules",
    READY_FOR_ASSESSMENT = "/main/examination/ready-for-assessments",
    SIGN_IN="sign-in",
    DASHBOARD_ASSESSMENT = "/main/dashboard-assessment",
    SIGNIN = "/sign-in",
    MYPROFILE = '/main/my-profile',
    ADMIN_USER_DASHBOARD = '/admin/admin-dashboard/user',
    ADMIN_ASSESSMENT_DASHBOARD = '/admin/admin-dashboard/assessment',
    ADD_USER = '/admin/add-user',
    CREATE_ASSESSMENT = '/admin/create-assessment',
    QUESTION_BANK = '/admin/admin-dashboard/question-bank',
    ADD_QUESTION = '/admin/add-question',
     HR_USER_DASHBOARD= '/hr/drive-dashboard',
     USER_SIGN_IN = '/admin/sign-in',
     ADD_SCHEDULE_DRIVE = '/hr/drive-dashboard/schedule-drive',
     VIEW_CANDIDATE_PAGE = '/hr/drive-dashboard/candidate-details',
     VIEW_CANDIDATE_DETAILS = '/hr/drive-dashboard/view-candidate',
     SUBMIT_SUCCESS_PAGE = '/main/success-page',
     ANONYMOUS_LOGIN = '/anonymous-login',
     CANDIDATE_PROFILE_DETAILS = '/hr/drive-dashboard/candidate-profile-details',
     CANDIDATE_NEW_PROFILE_DETAILS = '/hr/drive-dashboard/candidate-new-profile-details',
     QUESTION_GROUPS = '/admin/question-groups',
     LINK_QUESTIONS = '/admin/link-Questions',
     COLLEGE_ADMIN_SIGNIN = '/college-admin/college-admin-signin',
     COLLEGE_ADMIN_DASHBOARD = '/college-admin/college-dashboard',
     COLLEGE_DRIVE_DETAILS = '/college-admin/college-dashboard/college-drive-detail',
     COLLEGE_ADMIN_BASIC_DETAILS = '/college-admin/admin-basic-details',
     COLLEGE_CANDIDATE_DETAILS = '/college-admin/college-dashboard/college-candidate-details',
     REPORTED_QUESTION = 'admin/reported-question',
     WORKDAY_INVITE_URL = '/examination/test/invite?token=',
     GROUPS = '/admin/admin-dashboard/groups',
     CREATE_GROUPS = '/admin/add-group',
     QUESTION_STORE = '/admin/admin-dashboard/question-store',
     DATA_DELETION_REQUESTS = '/admin/admin-dashboard/data-deletion',
     APP_ENTRY_PAGE = '/app-entry-page',
     SERVER_HEALTH_CHECK = '/admin/server-health-check',
     PROCTORING_SERVER = '/admin/proctoring-server',
     WORKDAY_FAILURES = '/hr/drive-dashboard/workday-cosolidated-errors',
     WORKDAY_FAILED_REQUISITIONS = '/hr/drive-dashboard/workday-failed-requisitions',
     CONNECTED_DRIVE = '/examination/connected-drive',
     SR_DETAILS_PAGE = '/hr/drive-dashboard/sr-details',
     SR_CANDIDATE_DETAIL = '/hr/drive-dashboard/sr-candidate-detail',
     CONFIGURE_WORKFLOW = '/hr/drive-dashboard/configure-workflow',
     CONFIGURE_WORKFLOW_ENHANCED = '/hr/drive-dashboard/configure-workflow-enhanced',
     DOWNLOAD_PAGE = '/download'
     



}
